import MainTitle from './mainTitle'
import SubTitle from './subTitle'

const Title = MainTitle
Title.SubTitle = SubTitle

export default Title
